// frontend/src/components/Navbar.jsx
import React from 'react';
import { LanguageSelector } from './LanguageSelector';
import { ArrowRightLeft, Terminal } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguageStore } from '../store/useLanguageStore'; // 🟢 1. Importamos el Store

// ── Logo horizontal: importado desde assets (procesado por bundler)
import LogoHorizontal from '../assets/images/datiaFlow_horizontal.jpg';
// ── Isotipo: para favicon o navbar colapsada en móvil
import Isotipo from '../assets/images/isotipo.jpg';


export const Navbar = () => {
  const { t } = useLanguageStore(); // 🟢 2. Instanciamos el traductor

  return (
    // <nav className="flex items-center justify-between px-4 md:px-8 py-4 md:py-5 bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-slate-200">
    <nav className="flex items-center justify-between px-4 md:px-8 py-3 md:py-4 bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-slate-200 shadow-sm">

      {/* Contenedor del Logo */}
      <Link to="/" className="flex items-center cursor-pointer group shrink-0">
        {/* Móvil: logo cuadrado recortado para mostrar solo el isotipo */}
        <img
          src={Isotipo}
          alt="DatiaFlow"
          className="block md:hidden h-10 w-10 object-cover object-left group-hover:scale-105 transition-transform rounded-md"
        // className="block md:hidden h-10 w-10 object-cover object-center group-hover:scale-105 transition-transform rounded-md"
        />
        {/* Desktop: logo horizontal completo — h-12 = 48px, se ve bien */}
        <img
          src={LogoHorizontal}
          alt="DatiaFlow"
          className="hidden md:block h-12 w-auto group-hover:opacity-90 transition-opacity"
        />
      </Link>

      {/* Bloque Único de Acciones - Responsive */}
      <div className="flex items-center gap-3 md:gap-6">

        {/* 🟢 3. SELECTOR DE IDIOMA AQUÍ (Siempre visible) */}
        <div className="mr-2">
          <LanguageSelector />
        </div>

        {/* 'Solicitar Acceso' solo aparece de 'sm' (640px) en adelante para no apretar el móvil */}
        <Link
          to="/register"
          // className="hidden sm:block text-sm font-bold text-slate-500 hover:text-blue-600 transition-colors"
          className="hidden sm:block text-sm font-bold text-slate-500 hover:text-blue-600 transition-colors whitespace-nowrap"

        >
          {t('navbar.request_access') || 'Solicitar Acceso'}
        </Link>

        {/* Botón Acceder: Ajusta su tamaño dinámicamente */}
        <Link
          to="/login"
          // className="bg-slate-900 text-white px-4 md:px-6 py-2 md:py-2.5 rounded-full hover:bg-slate-800 transition-all shadow-md flex items-center gap-2 text-xs md:text-sm font-bold"
          className="bg-slate-900 text-white px-4 md:px-6 py-2 md:py-2.5 rounded-full hover:bg-slate-800 transition-all shadow-md flex items-center gap-2 text-xs md:text-sm font-bold whitespace-nowrap"

        >
          <Terminal className="w-3.5 h-3.5 md:w-4 md:h-4" />
          <span>{t('navbar.login') || 'Acceder'}</span>
        </Link>
      </div>
    </nav>
  );
};